import * as React from 'react';
import { useProject } from '../Contexts/Hooks/useProject';
import { RycIsProjectModule } from '../Enums/RycIsProjectModule';
import ProjectClientOffer from './ProjectClientOffer';
import { Backdrop, Box, Button, CircularProgress, Stack } from '@mui/material';
import { PrintOutlined, Send } from '@mui/icons-material';
import { useApi } from '../Api/useApi';
import { AuthRycApiClient, PrintRycApiClient, ProjectsRycApiClient } from '../Api/ApiServer';
import { useParams } from 'react-router';
import { downloadBlob } from '../Shared/DownloadBlob';
import { useSnackbar } from 'notistack';

export interface IProjectInternalOfferWrapperProps {
}

export default function ProjectInternalOfferWrapper(props: IProjectInternalOfferWrapperProps) {
    const { setCurrentModule, setMenuButtons } = useProject();
    const { authorizedApi } = useApi(PrintRycApiClient);
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(false);

    const printOffer = React.useCallback(async () => {
        setLoading(true);
        const data = await authorizedApi?.printBindingOfferReport(Number(params['id']));
        downloadBlob(data?.data, 'nabidka.pdf');

        setLoading(false);
        // data
    }, [authorizedApi, params, setLoading]);
    const printContract = React.useCallback(async () => {
        setLoading(true);
        const data = await authorizedApi?.printReport(Number(params['id']));
        downloadBlob(data?.data, 'SoD.pdf');

        setLoading(false);
        // data
    }, [authorizedApi, params, setLoading]);

    const sendToClient = React.useCallback(async () => {
        setLoading(true);
        const data = await authorizedApi?.sendProjectBudget(Number(params['id']));
        if (data?.ok) {
            enqueueSnackbar('Nabídka odeslána na email klientovi', { variant: 'success', autoHideDuration: 2000 });
        }
        else {
            enqueueSnackbar('Chyba odeslání nabídky, kontaktujte podporu', { variant: 'success', autoHideDuration: 2000 });
        }

        setLoading(false);
    }, [authorizedApi, params, enqueueSnackbar, setLoading]);

    React.useEffect(() => {
        setCurrentModule(RycIsProjectModule.InternalOffer);
    }, [setCurrentModule]);
    React.useEffect(() => {
        setMenuButtons(<Stack direction={'row'} spacing={1} alignItems={'center'}>
            <Button disabled={loading} variant='contained' sx={{
                width: { xs: 'auto', lg: '200px' },
                minWidth: { xs: '40px', lg: '200px' }
            }} color='secondary' onClick={printOffer} startIcon={<PrintOutlined />}><Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                    Tisk
                </Box></Button>
            <Button disabled={loading} variant='contained' sx={{
                width: { xs: 'auto', lg: '200px' },
                minWidth: { xs: '40px', lg: '200px' }
            }} color='secondary' onClick={printContract} startIcon={<PrintOutlined />}><Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                    Tisk SoD
                </Box></Button>
            <Button disabled={loading} variant='contained' sx={{
                width: { xs: 'auto', lg: '200px' },
                minWidth: { xs: '40px', lg: '200px' }
            }} onClick={sendToClient} startIcon={<Send />}><Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                    Odeslat klientovi
                </Box></Button>
        </Stack>);
    }, [setMenuButtons, loading]);
    return (
        <Box>
            <Backdrop sx={{ zIndex: 20 }} open={loading}>
                <CircularProgress />
            </Backdrop>
            <Box sx={{
                opacity: loading ? 0.6 : 1,
                pointerEvents: loading ? 'none' : 'auto'
            }}>
                <ProjectClientOffer clientSide={false} />
            </Box>
        </Box>
    );
}
